import React from 'react';

const Apple = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="34" viewBox="0 0 30 34" fill="none" {...props}>
      <g id="Frame 427323282">
        <path
          id="Vector"
          d="M15.324 7.67215C15.3881 5.92573 15.8788 4.39172 16.7844 3.10939C17.6946 1.82056 19.1992 0.905014 21.2588 0.38623C21.2725 0.449653 21.2867 0.513115 21.3015 0.576334V0.90816C21.3015 1.66059 21.119 2.52339 20.7588 3.47242C20.3813 4.39131 19.7913 5.25615 19.0076 6.03667C18.2747 6.72441 17.5967 7.17974 16.9974 7.38556C16.7996 7.44465 16.5283 7.5028 16.2007 7.55515C15.9094 7.60054 15.6171 7.6396 15.324 7.67215Z"
          fill={props?.fill || '#1B1F4D'}
        />
        <path
          id="Vector_2"
          d="M15.6639 10.2641C13.3374 10.2641 11.7222 8.20654 9.42733 8.20654C7.13257 8.20654 2.40491 10.3158 2.40491 17.5978C2.40491 24.8799 6.60313 29.5718 7.0727 30.1196C7.54218 30.6675 8.62813 32.0757 10.3105 32.0757C11.993 32.0757 13.8348 30.7381 15.6639 30.7381C17.4928 30.7381 19.7949 32.0757 21.2979 32.0757C22.8008 32.0757 23.419 31.463 24.4418 30.4063C25.4646 29.3495 27.4156 26.1246 28.0969 24.1891C26.9747 23.521 24.0001 21.7075 24.0001 17.5978C24.0001 14.8582 25.0013 12.5821 27.0038 10.7698C25.6901 9.061 24.1665 8.20654 22.433 8.20654C19.8326 8.20654 17.9903 10.2641 15.6639 10.2641Z"
          fill={props?.fill || '#1B1F4D'}
          stroke={props?.fill || '#1B1F4D'}
          stroke-width="3.12551"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export default Apple;
